<script lang="ts" setup>
import type { IProps } from './TextBox.types'
defineProps<IProps>()
</script>

<template>
  <article class="text-box">
    <h3
      class="text-box__title"
      v-html="box.title"
    />

    <div
      v-if="box.text"
      class="text-box__text"
      v-html="box.text"
    />

    <UiButton
      v-if="box.button"
      class="text-box__button"
      size="small"
      variant="primary"
      :to="box.button.to"
    >
      {{ box.button.text }}
    </UiButton>
  </article>
</template>

<style lang="scss" scoped>

.text-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding:3.2rem;
  background-color: $white;
  border-radius: 1.6rem;

  &__title {
    @include h8;
    margin-bottom: 1.2rem;
  }

  &__text {
    @include body-2;
    margin-bottom: 2.4rem;

    p {
      @include body-2;
    }
  }

  &__button {
    margin-top: auto;
  }
}
</style>
